import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import communicate from 'src/api/communicate';

export const LOAD_VACATIONS_REQUEST = 'LOAD_VACATIONS_REQUEST';
export const LOAD_VACATIONS_SUCCESS = 'LOAD_VACATIONS_SUCCESS';
export const LOAD_VACATIONS_FAIL = 'LOAD_VACATIONS_FAIL';

export const CONFIRM_VACATIONS_REQUEST = 'CONFIRM_VACATIONS_REQUEST';
export const CONFIRM_VACATIONS_SUCCESS = 'CONFIRM_VACATIONS_SUCCESS';
export const CONFIRM_VACATIONS_FAIL = 'CONFIRM_VACATIONS_FAIL';

export const UPDATE_SURPLUS_REQUEST = 'UPDATE_SURPLUS_REQUEST';
export const UPDATE_SURPLUS_SUCCESS = 'UPDATE_SURPLUS_SUCCESS';
export const UPDATE_SURPLUS_FAIL = 'UPDATE_SURPLUS_FAIL';

export const POST_SURPLUS_REQUEST = 'POST_SURPLUS_REQUEST';
export const POST_SURPLUS_SUCCESS = 'POST_SURPLUS_SUCCESS';
export const POST_SURPLUS_FAIL = 'POST_SURPLUS_FAIL';

const loadVacationsRequest = () => ({ type: LOAD_VACATIONS_REQUEST });
const loadVacationsSuccess = (vacations) => ({ type: LOAD_VACATIONS_SUCCESS, vacations });
const loadVacationsFail = () => ({ type: LOAD_VACATIONS_FAIL });

const confirmVacationsRequest = () => ({ type: CONFIRM_VACATIONS_REQUEST });
const confirmVacationsSuccess = (vacations) => ({ type: CONFIRM_VACATIONS_SUCCESS, vacations });
const confirmVacationsFail = () => ({ type: CONFIRM_VACATIONS_FAIL });

const updateSurplusRequest = () => ({ type: UPDATE_SURPLUS_REQUEST });
const updateSurplusSuccess = (vacations) => ({ type: UPDATE_SURPLUS_SUCCESS, vacations });
const updateSurplusFail = () => ({ type: UPDATE_SURPLUS_FAIL });

const postSurplusRequest = () => ({ type: POST_SURPLUS_REQUEST });
const postSurplusSuccess = (vacations) => ({ type: POST_SURPLUS_SUCCESS, vacations });
const postSurplusFail = () => ({ type: POST_SURPLUS_FAIL });

export const loadVacations = (request) => (dispatch) => {
  dispatch(loadVacationsRequest());
  return communicate({ url: 'Vacations', getParams: Utils.objects.getQueryStringFromObject(request) })
    .then(({ data }) => {
      dispatch(loadVacationsSuccess(data.Data));
    })
    .catch((err) => {
      toastrError(err);
      dispatch(loadVacationsFail());
    });
};

export const confirmVacations = (request) => (dispatch) => {
  dispatch(confirmVacationsRequest());
  return communicate({ url: 'ConfirmationDatas/ListFromCache', method: 'post', getParams: Utils.objects.getQueryStringFromObject(request) })
    .then(({ data }) => {
      toastrSuccess(data);
      dispatch(confirmVacationsSuccess(data.Data));
    })
    .catch((err) => {
      toastrError(err);
      dispatch(confirmVacationsFail());
    });
};

export const postSurplus = (data) => (dispatch) => {
  dispatch(postSurplusRequest());
  return communicate({ url: 'PeriodSurpluses', method: 'post', data })
    .then((response) => {
      dispatch(postSurplusSuccess(response.data.Data));
      toastrSuccess(response);
      return response.data.Data;
    })
    .catch((err) => {
      toastrError(err);
      dispatch(postSurplusFail());
    });
};

export const updateSurplus = (data) => (dispatch) => {
  dispatch(updateSurplusRequest());
  return communicate({ url: 'PeriodSurpluses', method: 'put', data })
    .then((response) => {
      dispatch(updateSurplusSuccess(response.data.Data));
      toastrSuccess(response);
      return response.data.Data;
    })
    .catch((err) => {
      toastrError(err);
      dispatch(updateSurplusFail());
    });
};
